import { IContentSetVersion } from "../interfaces/content/content-set-version.model.interface";
import { IMultivariateBasis } from "../interfaces/multivariate/multivariate-basis.model.interface";
import { IMultivariateBehaviour } from "../interfaces/multivariate/multivariate-behaviour.model.interface";
import { IState } from "../interfaces/config/state.model.interface";
import { MultivariateBasisType } from "../../enums/MultivariateBasisType";
import { IContentSetVersionTemplate } from "../interfaces/content/content-set-version-template.model.interface";
import { MultivariateBehaviourType } from "../../enums/MultivariateBehaviourType";
import { State } from "../config/state.model";

export class ContentSetVersionModel implements IContentSetVersion {
        public contentSetVersionId: number;
        public contentSetId: number;
        public name: string;
        public startDate: Date | null;
        public endDate: Date | null;
        public multivariateBasis: IMultivariateBasis;
        public multivariateBehaviour: IMultivariateBehaviour;
        public state: IState;
        public templates: IContentSetVersionTemplate[];

        constructor() {
            this.contentSetVersionId = 0;
            this.contentSetId = 0;
            this.name = "";
            this.multivariateBasis = { type: MultivariateBasisType.NotSpecified, name: "", description: "" };
            this.multivariateBehaviour = { type: MultivariateBehaviourType.NotSpecified, name: "", description: ""};
            this.state = new State();
            this.templates = [];
        }
    }
